import { SearchVehicleStep } from './SearchVehicleSteps';

export const SearchVehicle = () => {
  return SearchVehicleStep();
};
